// js-checkのチェック状態を確認して、ボタンの状態を更新する関数
function updateButtonState() {
    const checkboxes = document.querySelectorAll('input[type="checkbox"].js-check');
    const allChecked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
    const button = document.querySelector('button.js-check-target');

    if (button) {
        if (allChecked) {
            button.disabled = false;
            button.classList.remove('spiral__disabled');
        } else {
            button.disabled = true;
            button.classList.add('spiral__disabled');
        }
    }
}

// js-same-checkクラス関連の入力コピーおよびクリア関数
function copyInputValues() {
    const mappings = [
        { source: '.js-same-postal-1', target: '.js-same-target-postal-1' },
        { source: '.js-same-postal-2', target: '.js-same-target-postal-2' },
        { source: '.js-same-address-1', target: '.js-same-target-address-1' },
        { source: '.js-same-address-2', target: '.js-same-target-address-2' },
        { source: '.js-same-address-3', target: '.js-same-target-address-3' },
    ];

    mappings.forEach(({ source, target }) => {
        const sourceElement = document.querySelector(source);
        const targetElement = document.querySelector(target);

        if (sourceElement && targetElement) {
            targetElement.value = sourceElement.value;
        }
    });
}

function clearInputValues() {
    const targets = ['.js-same-target-postal-1', '.js-same-target-postal-2', '.js-same-target-address-1', '.js-same-target-address-2', '.js-same-target-address-3'];

    targets.forEach((target) => {
        const targetElement = document.querySelector(target);
        if (targetElement) {
            targetElement.value = '';
        }
    });
}

// 初期化とイベントリスナーの設定
window.addEventListener('load', () => {
    // js-check関連の初期化
    const checkboxes = document.querySelectorAll('input[type="checkbox"].js-check');
    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', updateButtonState);
    });
    updateButtonState();

    // js-same-check関連の初期化
    const checkbox = document.querySelector('.js-same-check');
    if (checkbox) {
        checkbox.addEventListener('change', (event) => {
            if (event.target.checked) {
                copyInputValues();
            } else {
                clearInputValues();
            }
        });
    }

    const inputFields = document.querySelectorAll('.js-same-postal-1, .js-same-postal-2, .js-same-address-1, .js-same-address-2, .js-same-address-3');
    inputFields.forEach((input) => {
        input.addEventListener('input', () => {
            if (checkbox && checkbox.checked) {
                copyInputValues();
            }
        });
    });

    // ダイアログ関連の初期化
    const showButtons = document.querySelectorAll('.showDialog');
    const favDialog = document.getElementById('favDialog');

    if (favDialog) {
        showButtons.forEach((item) => {
            item.addEventListener('click', (e) => {
                const button = e.target.closest('.showDialog');
                if (!button) return;

                const id = button.getAttribute('data-id');
                if (!id) return;

                const content = document.querySelector(`#${id}`)?.content;
                if (!content) return;

                const clone = document.importNode(content, true);
                const wrap = document.querySelector('#favDialog .content-main');

                while (wrap.firstChild) {
                    wrap.removeChild(wrap.firstChild);
                }

                wrap.appendChild(clone);
                favDialog.showModal();
            });
        });

        favDialog.addEventListener('click', (e) => {
            if (e.target === e.currentTarget || e.target.tagName.toLowerCase() === 'form') {
                favDialog.close();
            }
        });
    }
});
